import { en } from './en';
import { me } from './me';
import { sq } from './sq';
import { de } from './de';
import { ru } from './ru';
import { pl } from './pl';
import { hu } from './hu';
import { guide } from './guide';

export const translations = { en, me, sq, de, ru, pl, hu };
// Guide page labels live in guide.js — expose them as `guide.*` keys so nav/footer/explore can use t().
Object.keys(translations).forEach((l) => { const g = guide[l] || guide.en; translations[l].guide = { nav: g.nav, title: g.title, subtitle: g.subtitle }; });

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'me', name: 'Crnogorski', flag: '🇲🇪' },
  { code: 'sq', name: 'Shqip', flag: '🇦🇱' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'hu', name: 'Magyar', flag: '🇭🇺' }
];

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let result = translations[lang] || translations.en;
  
  for (const k of keys) {
    result = result?.[k];
    if (result === undefined) {
      // Fallback to English
      result = translations.en;
      for (const kk of keys) {
        result = result?.[kk];
      }
      break;
    }
  }
  
  return result || key;
};
